module.exports = __webpack_public_path__ + "static/media/fest8.6bd25944.png";